export default __webpack_public_path__ + "static/media/advantage_icon6.08cda9e2.png";